type ValueOf<T> = T[keyof T]

// ACL resource type: 0=Invalid, 1=PublicIP
export const ACLResourceType = {
  Invalid: 0,
  PublicIP: 1,
} as const
export type ACLResourceType = ValueOf<typeof ACLResourceType>

// ACL resource status: 0=Invalid, 1=Active, 2=Inactive
export const ACLResourceStatus = {
  Invalid: 0,
  Active: 1,
  Inactive: 2,
} as const
export type ACLResourceStatus = ValueOf<typeof ACLResourceStatus>

// traffic_direction: 0=Ingress, 1=Egress
export const ACLDirection = {
  Inbound: 0,
  Outbound: 1,
} as const
export type ACLDirection = ValueOf<typeof ACLDirection>

// default_action/action: 0=Allow, 1=Deny
export const ACLAction = {
  Allow: 0,
  Deny: 1,
} as const
export type ACLAction = ValueOf<typeof ACLAction>

// protocol: 0=ANY, 1=ICMP, 6=TCP, 17=UDP
export const ACLProtocol = {
  ANY: 0,
  ICMP: 1,
  TCP: 6,
  UDP: 17,
} as const
export type ACLProtocol = ValueOf<typeof ACLProtocol>

export const ACLProtocolName = {
  ANY: 'ANY',
  ICMP: 'ICMP',
  TCP: 'TCP',
  UDP: 'UDP',
} as const
export type ACLProtocolName = ValueOf<typeof ACLProtocolName>

// L3 rule state.status: 0=Invalid, 1=Pending, 2=Applied
export const ACLL3RuleState = {
  Invalid: 0,
  Pending: 1,
  Applied: 2,
} as const
export type ACLL3RuleState = ValueOf<typeof ACLL3RuleState>

export const ACL_DEFAULT_REMOTE_CIDRS = ['0.0.0.0/0', '::/0'] as const
export type ACLDefaultRemoteCIDR = (typeof ACL_DEFAULT_REMOTE_CIDRS)[number]

// Per-direction L3 rule limit and per-L3-rule L4 rule limit.
export const ACL_L3_RULE_LIMIT = 10
export const ACL_L4_RULE_LIMIT = 50
